import { makeStyles } from '@rbx/ui';

const useReturnsContainerStyles = makeStyles()((theme) => ({
  returnsHeading: {
    marginTop: 32,
    marginBottom: 16,
  },

  bold: {
    fontWeight: 500,
  },

  otherCodesTitle: {
    display: 'block',
    margin: '24px 0',
  },

  otherSuccess: {
    marginTop: 24,
  },

  otherSuccessDescription: {
    marginTop: 24,
  },

  accordionContainer: {
    marginTop: 24,
    '& > *': {
      borderTop: `solid 1px ${theme.palette.components.divider}`,
    },
    '& > :first-child': {
      borderTop: 'none',
    },
  },
}));

export default useReturnsContainerStyles;
